import { machineConfig } from "machine/config";
import { actions } from "./actions";
import { TAppContext, TAppState, TAppEvent } from "./types";

export const AppMachine = machineConfig<
  TAppContext,
  TAppState,
  TAppEvent
>(
  {
    id: "app",
    context: {
      isDesktop: window.innerWidth > 768,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          SET_IS_DESKTOP: {
            actions: "setIsDesktop",
          },
        },
      },
    },
  },
  {
    actions: actions,
  }
);
